/*
 * @Description: 
 * @Version: 2.0
 * @Autor: 一诺(丘汉文)
 * @Date: 2019-03-26 23:15:52
 * @Author: 一诺(丘汉文)
 * @LastEditors: lkz
 */
/**
 * import中的webpackChunkName，为按需加载生成的JS名称，请使用 [project-name]-[module-name]，示例如下
 */
export default [
  {
    path: '/businessHelpCenter',
    name: 'businessHelpCenter',
    redirect: '/businessHelpCenter/helpIndex',
    component: () => import (/* webpackChunkName: "example-businessKnowledge" */ '../views/businessKnowledge/index.vue'),
    children: [
      {
        path: 'helpIndex', // 以“/”开头的嵌套路径会被当作根路径，所以子路由上不用加“/”;在生成路由时，主路由上的path会被自动添加到子路由之前，所以子路由上的path不用在重新声明主路由上的path了。
        name: 'helpIndex',
        meta: {
          title: '商家帮助中心'
        },
        component: () => import (/* webpackChunkName: "example-businessKnowledge" */ '../views/businessKnowledge/components/helpIndex.vue')
      },
      {
        path: 'noticeList', // 以“/”开头的嵌套路径会被当作根路径，所以子路由上不用加“/”;在生成路由时，主路由上的path会被自动添加到子路由之前，所以子路由上的path不用在重新声明主路由上的path了。
        name: 'noticeList',
        meta: {
          title: '商家帮助中心'
        },
        component: () => import (/* webpackChunkName: "example-businessKnowledge" */ '../views/businessKnowledge/components/noticeList.vue')
      },
      {
        path: 'noticeDetails', // 以“/”开头的嵌套路径会被当作根路径，所以子路由上不用加“/”;在生成路由时，主路由上的path会被自动添加到子路由之前，所以子路由上的path不用在重新声明主路由上的path了。
        name: 'noticeDetails',
        meta: {
          title: '商家帮助中心'
        },
        component: () => import (/* webpackChunkName: "example-businessKnowledge" */ '../views/businessKnowledge/components/noticeDetails.vue')
      },
      {
        path: 'helplist', // 以“/”开头的嵌套路径会被当作根路径，所以子路由上不用加“/”;在生成路由时，主路由上的path会被自动添加到子路由之前，所以子路由上的path不用在重新声明主路由上的path了。
        name: 'helplist',
        component: () => import (/* webpackChunkName: "example-businessKnowledge" */ '../views/businessKnowledge/components/helplist.vue'),
        children: [
          {
            path: 'keywordsList', // 以“/”开头的嵌套路径会被当作根路径，所以子路由上不用加“/”;在生成路由时，主路由上的path会被自动添加到子路由之前，所以子路由上的path不用在重新声明主路由上的path了。
            name: 'keywordsList',
            meta: {
              title: '商家帮助中心'
            },
            component: () => import (/* webpackChunkName: "example-businessKnowledge" */ '../views/businessKnowledge/components/keywordsList.vue')
          },
          {
            path: 'cascadeList', // 以“/”开头的嵌套路径会被当作根路径，所以子路由上不用加“/”;在生成路由时，主路由上的path会被自动添加到子路由之前，所以子路由上的path不用在重新声明主路由上的path了。
            name: 'cascadeList',
            meta: {
              title: '商家帮助中心'
            },
            component: () => import (/* webpackChunkName: "example-businessKnowledge" */ '../views/businessKnowledge/components/cascadeList.vue')
          },
          {
            path: 'details', // 以“/”开头的嵌套路径会被当作根路径，所以子路由上不用加“/”;在生成路由时，主路由上的path会被自动添加到子路由之前，所以子路由上的path不用在重新声明主路由上的path了。
            name: 'details',
            meta: {
              title: '商家帮助中心'
            },
            component: () => import (/* webpackChunkName: "example-businessKnowledge" */ '../views/businessKnowledge/components/details.vue')
          }
        ]
      }
    ]
  }
]
